const Data = [
  {
    name: "Mehul Kumar Agarwal",
    position: "Sponsorship Head",
    imageUrl: "/assets/images/members/Heads26/MehulKumarAgarwal.jpg",
    facebookLink: "https://www.facebook.com/share/1945jkQMXe/",
    email: "mehul.24@kgpian.iitkgp.ac.in",
    linkedinLink: "https://www.linkedin.com/in/mehul-kumar-agarwal?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app"
  },
  {
    name: "Parth Vanarse",
    position: "Sponsorship Head",
    imageUrl: "/assets/images/members/Heads26/ParthVanarse.jpeg",
    facebookLink: "https://www.facebook.com/people/Parth-Vanarse/pfbid02K38qdRGzC8VuNJuwMT88TFWxdycVcQTKaba47H1VowbD8Vk92Cbdt7aFoRD2UDJal/?mibextid=ZbWKwL",
    email: "parthvanarse23.24@kgpian.iitkgp.ac.in",
    linkedinLink: "https://www.linkedin.com/in/parth-vanarse-059739326/"
  },
  {
    name: "Shiva Adarsh",
    position: "Sponsorship Head",
    imageUrl: "/assets/images/members/Heads26/ShivaAdarsh.webp",
    facebookLink: "",
    email: "adarsh56.24@kgpian.iitkgp.ac.in",
    linkedinLink: "https://www.linkedin.com/in/shiva-adarsh-00895a339"
  },
  {
    name: "Smriti Tubid",
    position: "Sponsorship Head",
    imageUrl: "/assets/images/members/Heads26/SmritiTubid.jpg",
    facebookLink: "",
    email: "smriti05.24@kgpian.iitkgp.ac.in",
    linkedinLink: "https://www.linkedin.com/in/smriti-tubid-8a32972ab?utm_source=share_via&utm_content=profile&utm_medium=member_android"
  },
  {
    name: "Sundram Kumar",
    position: "Sponsorship Head",
    imageUrl: "/assets/images/members/Heads26/SundramKumar.jpeg",
    facebookLink: "",
    email: "sundramjaiswal122.24@kgpian.iitkgp.ac.in",
    linkedinLink: "https://www.linkedin.com/in/sundramkumar/"
  },
  {
    name: "Daniyal Khan",
    position: "Sponsorship Head",
    imageUrl: "/assets/images/members/Heads26/DaniyalKhan.jpeg",
    facebookLink: "https://www.facebook.com/share/1EFP9pKxTx/",
    email: "daniyal.khan@gyws.org",
    linkedinLink: "https://www.linkedin.com/in/daniyal-khan-801844326"
  },
  {
    name: "Yug Birla",
    position: "Sponsorship Head",
    imageUrl: "/assets/images/members/Heads26/YugBirla.jpg",
    facebookLink: "",
    email: "2006yugb@gmail.com",
    linkedinLink: "https://www.linkedin.com/in/yug-birla-4b17b4321/"
  }
];

export default Data;